// Reference: https://medium.com/cruip/how-to-build-a-pricing-slider-react-71545d81d63d

import { Component, createRef } from "react"

class BuyInFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            buyInInputValue: 0,
            buyInInput: {
                0: 0,
                1: 1,
                2: 2.50,
                3: 5,
                4: 10,
                5: 25,
                6: 50,
                7: 100,
                8: 250,
                9: 500
            }
        }
    }

    slider = createRef()
    sliderValue = createRef()

    componentDidMount() {
        this.slider.current.setAttribute("min", 0)
        this.slider.current.setAttribute("max", Object.keys(this.state.buyInInput).length - 1)
        this.thumbSize = parseInt(
          window
            .getComputedStyle(this.sliderValue.current)
            .getPropertyValue("--thumb-size"),
          10
        )
        this.handleSliderValuePosition(this.slider.current)
    }

    handleBuyInRangeSlide = e => {
        this.setState({
            ...this.state,
            buyInInputValue: e.target.value,
        }, () => {
            this.handleSliderValuePosition(e.target)
            this.props.filterTournaments(this.getBuyInRange(this.state.buyInInput))
        })
    }

    handleSliderValuePosition = input => {
        const multiplier = input.value / input.max
        const thumbOffset = this.thumbSize * multiplier
        const buyInInputOffset = (this.thumbSize - this.sliderValue.current.clientWidth) / 2
        this.sliderValue.current.style.left = input.clientWidth * multiplier - thumbOffset + buyInInputOffset + "px"
    }

    getBuyInRange = (obj, pos) => {
        return pos !== undefined
          ? obj[this.state.buyInInputValue][pos]
          : obj[this.state.buyInInputValue]
    }

    render() {
        return (
            <div>
                    <label htmlFor="buy_in">Filter de toernooien op Buy-In:</label><br />
                    <input className="form-range" id="buy_in" type="range" ref={this.slider} defaultValue={this.state.buyInInputValue} onChange={this.handleBuyInRangeSlide} /><br />
                    <strong ref={this.sliderValue}>
                        Alle toernooien
                        {parseInt(this.state.buyInInputValue) === 0 ? "" : " met een Buy-In t/m " +
                        new Intl.NumberFormat("nl-NL", {
                            style: "currency",
                            currency: "EUR",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(this.getBuyInRange(this.state.buyInInput))
                        }
                    </strong>
            </div>
        )
    }
}

export default BuyInFilter